import { TranslateService } from "@ngx-translate/core";
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  PLATFORM_ID,
  Inject,
  HostListener,
} from "@angular/core";
import { UserService } from "../../../shared/services/user.service";
import { CommonService } from "../../../shared/services/common.service";
import { Router } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Input } from "hammerjs";
import { MasterApiService } from "src/app/shared/services/master-api.service";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  public checkoutForm: FormGroup;
  userLogedIn: boolean = false;
  currentUser: any;
  orderDetails: any;
  order_products: any[] = [];
  user_img = "";
  brief = "";
  existImg: boolean = false;
  datadone: boolean = false;
  user_full_name = "";
  usre_id: any;
  page_name =
    localStorage.getItem("front-lang") == "ar" ? "العناوين" : "Addresses";
  @ViewChild("newsletter", { static: false }) NewsLetterModal: TemplateRef<any>;

  public openDashboard: boolean = false;

  step1: boolean = false;
  step2: boolean = false;
  step3: boolean = false;
  step4: boolean = false;

  step11: boolean = false;
  step22: boolean = false;
  step33: boolean = false;

  addStep: boolean = false;
  editStep: boolean = false;
  public countries: any[] = [];
  public country_id = "";
  public country_name: any;
  public myAddresess: any[] = [];
  public cities: any[] = [];
  public Districts: any[] = [];
  public city_id = "";
  public district_id = "";
  public address_id = "";

  public title = "";
  public delete_address_id = "";
  public city_name: string = "";
  public district_name: string = "";

  public closeResult: string;
  public modalOpen: boolean = false;
  is_default: string = "1";
  haveDefault: boolean = false;
  user_name: string = "";
  last_name: string = "";
  mobile_data: string = "";
  mobile2_data: string = "";
  successUser_name: boolean = false;
  successLast_name: boolean = false;
  public errorUserNameMessage = "";
  public errorLastNameMessage = "";
  successMobile: boolean = false;
  successMobile2: boolean = false;
  errorMobileMessage = "";
  errorMobileMessage2 = "";
  successPassword: boolean = false;
  successconfirmPassword: boolean = false;
  errorPasswordMessage = "";
  errorconfirmPasswordMessage = "";
  phoneplaceholder: string = "";
  phone2placeholder: string = "";
  mobileLength: number = 0;
  keyLength: number = 0;
  valid_mobile: string = "";
  valid2_mobile: string = "";
  mobile_keys = [];
  mobilePattern = /^[0-9]+$/;
  mobileIsValid: boolean = false;
  mobile2IsValid: boolean = false;
  mobileIsInValid: boolean = false;
  mobile2IsInValid: boolean = false;
  country_code: any;
  image_mobile: string;
  _image_code: string;
  errorOccurred = false;
  errorOccurredMessage: string;
  currentUrl: string = "";
  hostName: string = "";

  constructor(
    private fb: FormBuilder,
    public Common: CommonService,
    public user: UserService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private MasterApiService: MasterApiService
  ) {
    // SET TITLE
    this.Common.setTitle(this.page_name);
    this._image_code = this.Common._imageUrlPlaces + "places/";

    this.checkoutForm = this.fb.group({
      title: ["", [Validators.required, Validators.maxLength(255)]],
      country: ["", Validators.required],
      city: ["", Validators.required],
      District: ["", Validators.required],
      is_default: ["1", Validators.required],
    });
  }

  ngOnInit(): void {
    this.getAllContanctInfo();
    this.checkOuth();
    // this.getPlaces(0);
    this.getAllAddress();
    this.hostName = this.Common.getDomainFromUrl();
    this.currentUrl = `https://${this.hostName}/pages/dashboard`;
  }

  checkLength() {
    this.valid_mobile = this.formatMobileNumber(this.mobile_data);

    this.mobileIsValid = false;
    if (
      !this.startsWithAny(this.mobile_keys, this.valid_mobile) &&
      this.valid_mobile.length >= this.keyLength
    ) {
      this.errorOccurred = true;
      this.successMobile = true;
      this.mobileIsInValid = true;

      this.translateService
        .get("invalid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorOccurredMessage = translatedMessage;
          this.errorMobileMessage = translatedMessage;
        });
    } else {
      this.errorOccurred = false;
      this.successMobile = false;
      this.mobileIsInValid = false;
      if (this.valid_mobile.length == this.mobileLength) {
        this.mobileIsValid = true;
      } else if (this.valid_mobile.length > this.mobileLength) {
        this.mobileIsInValid = true;
        this.mobileIsValid = false;
      } else {
        this.mobileIsValid = false;
      }
      this.errorOccurredMessage = "";
      this.errorMobileMessage = "";
    }
  }

  checkLength2() {
    this.valid2_mobile = this.formatMobileNumber(this.mobile2_data);
    this.mobile2IsValid = false;
    console.log(
      !this.startsWithAny(this.mobile_keys, this.valid2_mobile),
      this.mobile_keys,
      this.valid2_mobile
    );
    if (
      !this.startsWithAny(this.mobile_keys, this.valid2_mobile) &&
      this.valid2_mobile.length >= this.keyLength
    ) {
      this.errorOccurred = true;
      this.successMobile2 = true;
      this.mobile2IsInValid = true;

      this.translateService
        .get("invalid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorOccurredMessage = translatedMessage;
          this.errorMobileMessage2 = translatedMessage;
        });
    } else {
      this.errorOccurred = false;
      this.successMobile2 = false;
      this.mobile2IsInValid = false;
      if (this.valid2_mobile.length == this.mobileLength) {
        this.mobile2IsValid = true;
      } else if (this.valid2_mobile.length > this.mobileLength) {
        this.mobile2IsInValid = true;
        this.mobile2IsValid = false;
      } else {
        this.mobile2IsValid = false;
      }
      this.errorOccurredMessage = "";
      this.errorMobileMessage2 = "";
    }
  }

  startsWithAny(array, number) {
    const numStr = number.toString();
    return array.some((element) => numStr.startsWith(element.toString()));
  }
  formatMobileNumber(mobileNumber) {
    if (mobileNumber.charAt(0) !== "0" && mobileNumber.length > 0) {
      mobileNumber = "0" + mobileNumber;
    }
    return mobileNumber;
  }

  getAllContanctInfo() {
    // this.Common.getAllContanctInfo().subscribe((data) => {
    //   if (data.success) {
    //     this.country_id = data.data.country_info.id;
    //     this.onChangeCountry(this.country_id);
    //     this.country_code = data.data.country_info.country_code;
    //     this.image_mobile = this._image_code + data.data.country_info.image;
    //     this.mobile_keys = data.data.country_info.mobile_keys.split(",");
    //     this.mobileLength = parseInt(data.data.country_info.mobile_length);
    //     this.keyLength = this.mobile_keys[0].length;
    //     const len = this.mobileLength - this.keyLength;
    //     this.phoneplaceholder = this.mobile_keys[0];
    //     for (let index = 0; index < len; index++) {
    //       this.phoneplaceholder += "x";
    //     }
    //     this.phone2placeholder = this.mobile_keys[0];
    //     for (let index = 0; index < len; index++) {
    //       this.phone2placeholder += "x";
    //     }
    //     localStorage.setItem(
    //       "paymentInfo",
    //       JSON.stringify(this.Common.getAllPaymentMethods(data.data))
    //     );
    //   }
    // });
    this.MasterApiService.getCurrentDataContact().subscribe(
      (dataContact) => {
        if (!dataContact) {
          console.error("Data contact information is undefined or null");
          return;
        }
        console.log("dataContact", dataContact);
        this.country_id = dataContact.country_info.id;
        console.log("country_id", this.country_id);

        this.onChangeCountry(this.country_id);
        this.country_code = dataContact.country_info.country_code;
        this.image_mobile = this._image_code + dataContact.country_info.image;
        this.mobile_keys = dataContact.country_info.mobile_keys.split(",");
        this.mobileLength = parseInt(dataContact.country_info.mobile_length);
        this.keyLength = this.mobile_keys[0].length;
        const len = this.mobileLength - this.keyLength;
        this.phoneplaceholder = this.mobile_keys[0];
        for (let index = 0; index < len; index++) {
          this.phoneplaceholder += "x";
        }
        this.phone2placeholder = this.mobile_keys[0];
        for (let index = 0; index < len; index++) {
          this.phone2placeholder += "x";
        }
        localStorage.setItem(
          "paymentInfo",
          JSON.stringify(this.Common.getAllPaymentMethods(dataContact))
        );
      },
      (error) => {
        console.error("Error fetching contact info", error);
      }
    );
  }

  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }
  seasons: string[] = ["Winter", "Spring", "Summer", "Autumn"];

  loginclicked: boolean = false;

  // goToLogin() {
  //   this.loginclicked = true;
  // }
  // close() {
  //   this.loginclicked = false;
  // }

  deleteAddress(id) {
    if (this.delete_address_id != "") {
      this.step11 = false;
      this.step22 = true;
      this.step33 = false;

      if (this.userLogedIn == true) {
        let body = {
          address_id: id,
        };
        this.user.deleteAddress(body).subscribe((data) => {
          if (data.success) {
            this.step11 = false;
            this.step22 = false;
            this.step33 = true;
            this.getAllAddress();
          } else {
            this.step11 = false;
            this.step22 = false;
            this.step33 = false;
            return;
          }
        });
      } else {
        // this.router.navigate(["/pages/login"]);
        this.goToLogin();
      }
    }
  }

  onChangeCountry(value) {
    console.log("value", value);
    console.log(this.checkoutForm.get("is_default"));

    if (value != "") {
      this.Common.getPlaces(value, this.city_id).subscribe((data) => {
        if (data.data) {
          this.cities = data.data;
          console.log("city", this.cities);
        } else {
          // console.log("no data in countries");
        }
      });

      for (let i = 0; i < this.countries.length; i++) {
        if (this.countries[i].id == value) {
          this.country_name = this.countries[i].pla_name;
        }
      }
    }
  }
  onChangeCity(value: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.district_id = "";
      console.log(this.checkoutForm.get("is_default"));

      if (value != "") {
        this.Common.getPlaces(this.country_id, value).subscribe((data) => {
          if (data.data) {
            this.Districts = data.data;
            console.log("Districts", this.Districts);
            resolve();
          } else {
            reject("No data in countries");
          }
        });

        for (let i = 0; i < this.countries.length; i++) {
          if (this.countries[i].id == value) {
            this.country_name = this.countries[i].pla_name;
          }
        }
      } else {
        resolve(); // Resolve immediately if value is empty
      }
    });
  }

  async openModal(index: number, status: string) {
    this.resetForm();
    this.successUser_name = false;
    this.successLast_name = false;
    this.successPassword = false;
    this.successconfirmPassword = false;
    this.successMobile = false;
    this.mobileIsInValid = false;
    this.mobileIsValid = false;
    this.successMobile2 = false;
    this.mobile2IsInValid = false;
    this.mobile2IsValid = false;
    this.step22 = false;
    this.step33 = false;
    this.step11 = false;
    this.step2 = false;
    this.step3 = false;
    this.step4 = false;

    this.addStep = false;
    this.editStep = false;
    if (status == "add") {
      this.step1 = true;
      this.step4 = false;
    }
    this.is_default = "1";
    if (status == "edit") {
      this.city_id = this.myAddresess[index].city_id;
      this.city_name = this.myAddresess[index].city_name;
      await this.onChangeCity(this.city_id);
      this.step1 = false;
      this.step4 = true;
      // console.log("address", this.myAddresess[index]);
      this.district_id =
        this.myAddresess[index].district_id == "0"
          ? ""
          : this.myAddresess[index].district_id;
      this.district_name = this.myAddresess[index].district_name || "";
      this.address_id = this.myAddresess[index].id;
      this.title = this.myAddresess[index].title;
      this.user_name = this.myAddresess[index].user_name;
      this.last_name = this.myAddresess[index].last_name;
      this.mobile_data = this.myAddresess[index].mobile;
      this.mobile2_data = this.myAddresess[index].mobile_2;
      this.is_default = this.myAddresess[index].is_default;
      console.log("dist", this.district_id);
      if (this.mobile2_data) {
        this.valid2_mobile = this.formatMobileNumber(this.mobile2_data);
      } else {
        this.valid2_mobile = "";
      }
      if (this.mobile_data) {
        this.valid_mobile = this.formatMobileNumber(this.mobile_data);
      } else {
        this.valid_mobile = "";
      }
    } else {
      this.title = "";
      this.city_id = "";
      this.district_id = "";
      this.city_name = "";
      this.district_name = "";
      this.user_name = this.currentUser.user_name;
      this.last_name = this.currentUser.last_name || "";
      this.mobile_data = this.currentUser.mobile;
      this.mobile2_data = "";
      if (this.mobile_data) {
        this.valid_mobile = this.formatMobileNumber(this.mobile_data);
      } else {
        this.valid_mobile = "";
      }
    }
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      this.modalService
        .open(this.NewsLetterModal, {
          size: "md",
          ariaLabelledBy: "NewsLetter-Modal",
          centered: true,
          windowClass: "theme-modal newsletterm NewsLetterModal",
        })
        .result.then(
          (result) => {
            this.modalOpen = true;
            `Result ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }
  resetForm() {
    this.checkoutForm.controls["title"].reset();
    this.checkoutForm.controls["title"].setErrors(null);
    this.checkoutForm.controls["title"].markAsUntouched();
    this.checkoutForm.controls["city"].reset();
    this.checkoutForm.controls["city"].setErrors(null);
    this.checkoutForm.controls["city"].markAsUntouched();
    this.checkoutForm.controls["District"].reset();
    this.checkoutForm.controls["District"].setErrors(null);
    this.checkoutForm.controls["District"].markAsUntouched();
  }

  opendeleteModal(address_id) {
    this.step2 = false;
    this.step3 = false;
    this.step1 = false;
    this.step4 = false;
    this.step22 = false;
    this.step33 = false;
    this.step11 = true;

    if (address_id != "" && address_id > 0) {
      this.delete_address_id = address_id;
      if (isPlatformBrowser(this.platformId)) {
        // For SSR
        this.modalService
          .open(this.NewsLetterModal, {
            size: "md",
            ariaLabelledBy: "NewsLetter-Modal",
            centered: true,
            windowClass: "theme-modal newsletterm NewsLetterModal",
          })
          .result.then(
            (result) => {
              this.modalOpen = true;
              `Result ${result}`;
            },
            (reason) => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
          );
      }
    }
  }

  addAddress() {
    this.successUser_name = false;
    this.successLast_name = false;
    this.successPassword = false;
    this.successconfirmPassword = false;
    this.successMobile = false;
    this.mobileIsInValid = false;
    this.mobileIsValid = false;
    this.successMobile2 = false;
    this.mobile2IsInValid = false;
    this.mobile2IsValid = false;

    if (this.user_name == "" || this.user_name.length < 3) {
      this.successUser_name = true;
      this.translateService
        .get("first name message")
        .subscribe((translatedMessage: any) => {
          this.errorUserNameMessage = translatedMessage;
        });
      return;
    }
    // if (this.last_name == "" || this.last_name.length < 3) {
    //   this.successLast_name = true;
    //   this.translateService
    //     .get("last name message")
    //     .subscribe((translatedMessage: any) => {
    //       this.errorLastNameMessage = translatedMessage;
    //     });
    //   return;
    // }

    if (!this.startsWithAny(this.mobile_keys, this.valid_mobile)) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("invalid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (this.valid_mobile.length < this.mobileLength) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("short mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (this.valid_mobile.length > this.mobileLength) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("long mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (!this.mobilePattern.test(this.valid_mobile)) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("valid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    }
    if (!this.successMobile) {
      this.mobileIsValid = true;
      this.mobileIsInValid = false;
    }
    console.log(this.valid2_mobile);
    if (this.mobile2_data != "") {
      if (!this.startsWithAny(this.mobile_keys, this.valid2_mobile)) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("invalid mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (this.valid2_mobile.length < this.mobileLength) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("short mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (this.valid2_mobile.length > this.mobileLength) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("long mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (!this.mobilePattern.test(this.valid2_mobile)) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("valid mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      }
      if (!this.successMobile2) {
        this.mobile2IsValid = true;
        this.mobile2IsInValid = false;
      }
    }

    if (
      this.title == "" ||
      this.city_id == "" ||
      this.country_id == "" ||
      this.district_id == ""
    ) {
      this.checkoutForm.markAllAsTouched();
      return;
    }

    this.step2 = true;
    this.addStep = true;

    this.step3 = false;
    this.step1 = false;
    this.step4 = false;
    if (this.userLogedIn == true) {
      let body = {
        title: this.title,
        city_id: this.city_id,
        city_name: this.city_name,
        district_id: this.district_id,
        district_name: this.district_name,
        country_id: this.country_id,

        is_default: this.is_default,
        user_name: this.user_name,
        last_name: this.last_name,
        mobile: this.valid_mobile,
        mobile_2: this.valid2_mobile,
      };
      this.user.addAddress(body).subscribe((data) => {
        if (data.success) {
          this.step1 = false;
          this.step4 = false;
          this.step2 = false;
          this.step3 = true;
          this.addStep = true;
          this.getAllAddress();
        } else {
          return;
        }
      });
    } else {
      // this.router.navigate(["/pages/login"]);
      this.goToLogin();
    }
  }

  editAddress() {
    this.successUser_name = false;
    this.successLast_name = false;
    this.successPassword = false;
    this.successconfirmPassword = false;
    this.successMobile = false;
    this.mobileIsInValid = false;
    this.mobileIsValid = false;
    this.successMobile2 = false;
    this.mobile2IsInValid = false;
    this.mobile2IsValid = false;

    if (!this.user_name || this.user_name.length < 3) {
      this.successUser_name = true;
      this.translateService
        .get("first name message")
        .subscribe((translatedMessage: any) => {
          this.errorUserNameMessage = translatedMessage;
        });
      return;
    }
    // if (!this.last_name || this.last_name.length < 3) {
    //   this.successLast_name = true;
    //   this.translateService
    //     .get("last name message")
    //     .subscribe((translatedMessage: any) => {
    //       this.errorLastNameMessage = translatedMessage;
    //     });
    //   return;
    // }

    if (!this.startsWithAny(this.mobile_keys, this.valid_mobile)) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("invalid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (this.valid_mobile.length < this.mobileLength) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("short mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (this.valid_mobile.length > this.mobileLength) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("long mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (!this.mobilePattern.test(this.valid_mobile)) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("valid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    }
    if (!this.successMobile) {
      this.mobileIsValid = true;
      this.mobileIsInValid = false;
    }
    if (this.mobile2_data != null && this.mobile2_data != "") {
      console.log(
        !this.startsWithAny(this.mobile_keys, this.valid2_mobile),
        this.mobile_keys,
        this.valid2_mobile,
        this.mobile2_data,
        this.valid_mobile
      );
      if (!this.startsWithAny(this.mobile_keys, this.valid2_mobile)) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("invalid mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (this.valid2_mobile.length < this.mobileLength) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("short mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (this.valid2_mobile.length > this.mobileLength) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("long mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (!this.mobilePattern.test(this.valid2_mobile)) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("valid mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      }
      if (!this.successMobile2) {
        this.mobile2IsValid = true;
        this.mobile2IsInValid = false;
      }
    }
    console.log("district_id", this.checkoutForm.controls.District);

    if (
      this.title == "" ||
      this.city_id == "" ||
      this.country_id == "" ||
      this.district_id == "" ||
      this.district_id == "0"
    ) {
      this.checkoutForm.markAllAsTouched();
      return;
    }
    this.step2 = true;
    this.editStep = true;
    this.step3 = false;
    this.step1 = false;
    this.step4 = false;
    if (this.userLogedIn == true) {
      let body = {
        id: this.address_id,
        title: this.title,
        city_id: this.city_id,
        city_name: this.city_name,
        district_id: this.district_id,
        district_name: this.district_name,
        country_id: this.country_id,
        is_default: this.is_default,
        user_name: this.user_name,
        last_name: this.last_name,
        mobile: this.valid_mobile,
        mobile_2: this.valid2_mobile,
      };
      this.user.editAddress(body).subscribe((data) => {
        this.getAllAddress();
        if (data.success) {
          this.step1 = false;
          this.step4 = false;
          this.step2 = false;
          this.step3 = true;
          this.editStep = true;
          // this.getAllAddress();
        } else {
          return;
        }
      });
    } else {
      this.goToLogin();
    }
  }

  getAllAddress() {
    this.user.getAllAddress().subscribe((data) => {
      if (data.data) {
        this.myAddresess = data.data;
        this.myAddresess.forEach((ele) => {
          if (ele.is_default == 1) {
            this.haveDefault = true;
          }
        });
      } else {
        return;
      }
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  checkOuth() {
    if (this.user.getToken() !== null) {
      this.userLogedIn = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser["id"];
      this.user_img = this.currentUser["img"];
      this.brief = this.currentUser["brief"];
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_full_name = this.currentUser["user_name"];
      this.user_name = this.currentUser.user_name;
      this.last_name = this.currentUser.last_name || "";
      this.mobile_data = this.currentUser.mobile;
      this.valid_mobile = this.formatMobileNumber(this.mobile_data);
    } else {
      this.userLogedIn = false;
      this.currentUser = [];
      this.usre_id = "";
      this.existImg = false;
      this.user_img = "";
      this.router.navigate(["/"]);
    }
  }
  userLogOut() {
    localStorage.removeItem("currentUserFront");
    localStorage.removeItem("clientToken");
    this.userLogedIn = false;
    this.currentUser = [];
    this.usre_id = "";
    this.user_img = "";
    this.user.logout();
    this.Common.UpdatedSetting.next("logout");
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
  }

  // calculateTextColor(themeVariable: string): string {
  //   const cssValue = getComputedStyle(
  //     document.querySelector("app-root")
  //   ).getPropertyValue(themeVariable);
  //   return this.Common.tinyColor(cssValue);
  // }
  step5Reached: boolean = false;
  stepSuccessReached: boolean = false;
  timeoutId: any;

  @ViewChild("login") loginSection;
  @ViewChild("loginFast") loginFast;

  goToLogin() {
    this.loginclicked = true;
  }

  close() {
    this.loginclicked = false;
    this.step5Reached = false;
    this.clearTimeout();
    if (this.stepSuccessReached) {
      window.location.reload();
    }
  }

  onStep5Reached() {
    this.step5Reached = true;
    this.startTimeout();
  }
  onstepSuccessReached() {
    this.stepSuccessReached = true;
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.close();
    }, 2000);
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.loginFast || !this.loginSection) {
      return;
    }
    const clickedInside = this.loginFast.nativeElement.contains(event.target);
    const clickedButton = this.loginSection.nativeElement.contains(
      event.target
    );

    if (clickedInside && this.loginclicked) {
      if (this.step5Reached) {
        this.close();
      }
    } else if (!clickedInside && clickedButton && this.loginclicked) {
      this.close();
    }
  }
}
